import React from 'react';
import { Button, Tooltip } from 'chaser-components';
import { string, object } from 'prop-types';
import useContact from '../../../hooks/useContact';
import config from '../../../config';
import { isInvoicePdfAvailable } from '../../../util/constants';

const InvoicePDF = ({ invoiceId, invoicePdfLink, accountingSoftware, features }) => {
  const { orgId, contactId } = useContact();

  const canDownloadInvoicePDF = isInvoicePdfAvailable(accountingSoftware, !!invoicePdfLink);

  const shouldHaveInvoicePdfLink =
    features?.openapi && features?.nosync_invoice_pdf ? !!invoicePdfLink : true;

  const isOpenAPIWithNosync = features?.openapi && features?.nosync_invoice_pdf;

  if (!canDownloadInvoicePDF && !isOpenAPIWithNosync) return null;

  return (
    <Tooltip
      position="right"
      disable={shouldHaveInvoicePdfLink}
      content="Invoice PDF is not available to download"
    >
      <Button
        style={{
          padding: '5px',
          opacity: shouldHaveInvoicePdfLink ? 1 : 0.5,
          cursor: shouldHaveInvoicePdfLink ? 'pointer' : 'not-allowed',
        }}
        as={shouldHaveInvoicePdfLink ? 'a' : 'button'}
        target={shouldHaveInvoicePdfLink ? '_blank' : undefined}
        size="narrow"
        href={
          shouldHaveInvoicePdfLink
            ? `${config.apiUrl}/c/${orgId}/d/${contactId}/i/${invoiceId}/pdf`
            : undefined
        }
        appearance="secondary"
        icon="download"
        disabled={!shouldHaveInvoicePdfLink}
      />
    </Tooltip>
  );
};

InvoicePDF.propTypes = {
  invoiceId: string.isRequired,
  invoicePdfLink: string,
  accountingSoftware: string,
  features: object,
};

export default InvoicePDF;
